/**
 * hz-homepage.js — Arhaus-Inspired Dawn Theme
 * Vanilla JS only. No libraries.
 */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     SCROLL REVEAL
  ---------------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.hz-reveal');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ----------------------------------------------------------
     VIDEO QUOTE — PLAY / PAUSE TOGGLE
  ---------------------------------------------------------- */
  function initVideoQuote() {
    var btns = document.querySelectorAll('.hz-vq__playbtn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      var videoId = btn.getAttribute('data-video-id');
      if (!videoId) return;
      var video = document.getElementById(videoId);
      if (!video) return;

      var iconPause = btn.querySelector('.hz-vq__playbtn-icon--pause');
      var iconPlay  = btn.querySelector('.hz-vq__playbtn-icon--play');

      btn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          if (iconPause) iconPause.style.display = '';
          if (iconPlay)  iconPlay.style.display  = 'none';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          if (iconPause) iconPause.style.display = 'none';
          if (iconPlay)  iconPlay.style.display  = '';
          btn.setAttribute('aria-label', 'Play video');
        }
      });
    });
  }

  /* ----------------------------------------------------------
     COLLECTIONS CAROUSEL
     - Drag to scroll (mouse)
     - Wheel hijack: vertical mousewheel → horizontal scroll (fixes page scroll bug)
     - Arrow buttons: prev/next with smart show/hide
       • Prev arrow hidden at start, appears once user has scrolled
       • Next arrow hidden when at the end
  ---------------------------------------------------------- */
  function initCollections() {
    var wraps = document.querySelectorAll('.hz-collections__wrap');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var grid = wrap.querySelector('.hz-collections__grid');
      var btnPrev = wrap.querySelector('.hz-collections__arrow--prev');
      var btnNext = wrap.querySelector('.hz-collections__arrow--next');
      if (!grid) return;

      /* --- Arrow visibility --- */
      function updateArrows() {
        var atStart = grid.scrollLeft <= 4;
        var atEnd   = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 4;
        if (btnPrev) {
          if (atStart) { btnPrev.classList.remove('is-visible'); btnPrev.setAttribute('aria-hidden', 'true'); }
          else         { btnPrev.classList.add('is-visible');    btnPrev.removeAttribute('aria-hidden'); }
        }
        if (btnNext) {
          if (atEnd) { btnNext.classList.add('is-hidden');    btnNext.setAttribute('aria-hidden', 'true'); }
          else       { btnNext.classList.remove('is-hidden'); btnNext.removeAttribute('aria-hidden'); }
        }
      }

      /* --- Scroll amount: width of one card + gap --- */
      function scrollAmount() {
        var card = grid.querySelector('.hz-col-card');
        return card ? card.offsetWidth + 10 : Math.round(grid.clientWidth * 0.7);
      }

      /* --- Arrow clicks --- */
      if (btnPrev) {
        btnPrev.addEventListener('click', function () {
          grid.scrollLeft -= scrollAmount();
        });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function () {
          grid.scrollLeft += scrollAmount();
        });
      }

      /* --- Scroll listener → update arrows --- */
      grid.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows(); /* set initial state */

      /* --- Wheel: passive listener only — no hijack, no preventDefault ---
         The old wheel hijack called e.preventDefault() on all vertical scroll
         events over the grid, which completely blocked page scrolling whenever
         the cursor was on the carousel (desktop) or a touch was on a card (mobile).
         Removed. Native horizontal scroll via trackpad/touch works fine without it. */
      grid.addEventListener('wheel', function (e) {
        /* Only convert pure horizontal trackpad swipes — never touch vertical scroll */
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          grid.scrollLeft += e.deltaX;
        }
        /* Vertical wheel → let page scroll naturally (no preventDefault) */
      }, { passive: true });

      /* --- Drag to scroll (mouse) --- */
      var isDown  = false;
      var startX  = 0;
      var scrollX = 0;

      grid.addEventListener('mousedown', function (e) {
        isDown  = true;
        startX  = e.pageX - grid.offsetLeft;
        scrollX = grid.scrollLeft;
        grid.style.userSelect = 'none';
      });
      grid.addEventListener('mouseleave', function () { isDown = false; });
      grid.addEventListener('mouseup',    function () { isDown = false; grid.style.userSelect = ''; });
      grid.addEventListener('mousemove',  function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x    = e.pageX - grid.offsetLeft;
        var walk = (x - startX) * 1.4;
        grid.scrollLeft = scrollX - walk;
      });
    });
  }

  /* ----------------------------------------------------------
     SHOP THE LOOK — HOTSPOT POPOVERS
  ---------------------------------------------------------- */
  function initHotspots() {
    var hotspots = document.querySelectorAll('.hz-hotspot');
    if (!hotspots.length) return;

    function closeAll() {
      hotspots.forEach(function (h) { h.classList.remove('is-active'); });
    }

    hotspots.forEach(function (hs) {
      var btn = hs.querySelector('.hz-hotspot__btn');
      if (!btn) return;
      btn.setAttribute('tabindex', '0');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = hs.classList.contains('is-active');
        closeAll();
        if (!open) hs.classList.add('is-active');
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
        if (e.key === 'Escape') closeAll();
      });
    });

    document.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ----------------------------------------------------------
     INIT
  ---------------------------------------------------------- */
  function init() {
    initReveal();
    initVideoQuote();
    initCollections();
    initHotspots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());